import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.repeat";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import multiSearchMixin from '@/mixins/multiSearchDigitalTwins';
import { localizeDate, isNullOrEmpty } from '@/utils/vuex';
import { calculateNextExecutionTimes } from '@/utils/recurringTasks';
import { isEqual } from 'lodash';
var COUNT_NEXT_EXECUTIONS = 3;
var FREQUENCY_OPTIONS = ['yearly', 'monthly', 'daily']; // 'hourly' is hidden, might be available in future

export default {
  name: 'CoreCsvExportFrequency',
  mixins: [multiSearchMixin],
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          frequency: 'monthly',
          month: null,
          day: null,
          hour: null,
          minute: null
        };
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      internalModel: _objectSpread({}, this.value),
      countNextExecutions: COUNT_NEXT_EXECUTIONS,
      frequencyOptions: FREQUENCY_OPTIONS,
      formIsValid: false,
      disabledTimeInputs: [],
      requiredTimeRules: [],
      nextExecutionTimes: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'color'])), {}, {
    computedRules: function computedRules() {
      var _this = this;

      return {
        rangeMinute: function rangeMinute(v) {
          return v <= 59 && v >= 0 || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.invalidField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.minute')
          });
        },
        rangeHour: function rangeHour(v) {
          return v <= 23 && v >= 0 || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.invalidField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.hour')
          });
        },
        rangeDay: function rangeDay(v) {
          return v <= 31 && v >= 1 || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.invalidField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.day')
          });
        },
        rangeMonth: function rangeMonth(v) {
          return v <= 12 && v >= 1 || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.invalidField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.month')
          });
        },
        reqMinute: function reqMinute(v) {
          return v !== undefined && v !== null && v !== '' || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.requiredField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.minute')
          });
        },
        reqHour: function reqHour(v) {
          return v !== undefined && v !== null && v !== '' || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.requiredField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.hour')
          });
        },
        reqDay: function reqDay(v) {
          return v !== undefined && v !== null && v !== '' || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.requiredField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.day')
          });
        },
        reqMonth: function reqMonth(v) {
          return v !== undefined && v !== null && v !== '' || _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.requiredField', {
            item: _this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.month')
          });
        }
      };
    }
  }),
  watch: {
    internalModel: {
      handler: function handler() {
        var _this2 = this;

        this.setDisabledFields();
        this.setRequiredRules();
        this.$refs.formFrequency.validate();
        this.$nextTick(function () {
          _this2.getNextExecutionTimes();

          _this2.$emit('input', _objectSpread(_objectSpread({}, _this2.internalModel), {}, {
            formIsValid: _this2.formIsValid
          }));
        });
      },
      deep: true
    },
    value: {
      handler: function handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = _objectSpread({}, this.value);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    this.setRequiredRules();
    this.setDisabledFields();
    this.$refs.formFrequency.validate();
    this.getNextExecutionTimes();
    this.$emit('input', _objectSpread(_objectSpread({}, this.internalModel), {}, {
      formIsValid: this.formIsValid
    }));
  },
  methods: {
    localizeDate: localizeDate,
    isNullOrEmpty: isNullOrEmpty,
    setRequiredRules: function setRequiredRules() {
      var _this3 = this;

      this.requiredTimeRules = {};

      if (this.internalModel.repeat === 'hourly') {
        this.requiredTimeRules['minute'] = [this.computedRules.reqMinute, this.computedRules.rangeMinute];
      } else if (this.internalModel.repeat === 'daily') {
        this.requiredTimeRules['hour'] = [this.computedRules.reqHour, this.computedRules.rangeHour];
        this.requiredTimeRules['minute'] = [this.computedRules.reqMinute, this.computedRules.rangeMinute];
      } else if (this.internalModel.repeat === 'monthly') {
        this.requiredTimeRules['day'] = [this.computedRules.reqDay, this.computedRules.rangeDay];
        this.requiredTimeRules['hour'] = [this.computedRules.reqHour, this.computedRules.rangeHour];
        this.requiredTimeRules['minute'] = [this.computedRules.reqMinute, this.computedRules.rangeMinute];
      } else {
        this.requiredTimeRules['month'] = [this.computedRules.reqMonth, this.computedRules.rangeMonth];
        this.requiredTimeRules['day'] = [this.computedRules.reqDay, this.computedRules.rangeDay, // Extra rule for February
        function (v) {
          return _this3.month === 2 && v <= 29 && v >= 1 || _this3.month !== 2 || _this3.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.invalidField', {
            item: _this3.$i18n_t('BackgroundJobs.ScheduledExports.dialog.frequency.day')
          });
        }];
        this.requiredTimeRules['hour'] = [this.computedRules.reqHour, this.computedRules.rangeHour];
        this.requiredTimeRules['minute'] = [this.computedRules.reqMinute, this.computedRules.rangeMinute];
      }
    },
    setDisabledFields: function setDisabledFields() {
      if (this.internalModel.repeat === 'hourly') {
        this.disabledTimeInputs = ['month', 'day', 'hour'];
      } else if (this.internalModel.repeat === 'daily') {
        this.disabledTimeInputs = ['month', 'day'];
      } else if (this.internalModel.repeat === 'monthly') {
        this.disabledTimeInputs = ['month'];
      } else {
        this.disabledTimeInputs = [];
      }
    },
    getNextExecutionTimes: function getNextExecutionTimes() {
      if (!this.formIsValid) {
        this.nextExecutionTimes = [];
        return;
      }

      try {
        var nextExecutionTimes = calculateNextExecutionTimes(this.internalModel.repeat, this.countNextExecutions, this.internalModel.month, this.internalModel.day, this.internalModel.hour, this.internalModel.minute);
        this.nextExecutionTimes = nextExecutionTimes;
      } catch (error) {
        console.error(error);
        this.nextExecutionTimes = [];
      }
    }
  }
};